<template>
  <div>
    <div class="check-center">
      <p class="check-text">BOOK A NEW SHIPMENT</p>
      <ByForm :rules="rules" :model="formData" ref="ruleForm">
        <div class="check-form_flex check-form__group">
          <ByFormItem prop="from" required class="check-form-item">
            <ByAutocomplete ref="from" placeholder="Origin Airport" v-model="formData.fromLabel" :fetchSuggestions="
                (queryString, cb) =>
                  fetchSuggestions(queryString, cb, startAirDatas)
              " valueKey="value" labelKey="label" @select="
                (item) => {
                  formData.from = item.value;
                  formData.startItem = item;
                  $refs['end'].focus();
                }
              ">
              <template slot="prefix">
                <svg-icon size="20" name="juxing1"></svg-icon>
                <span>From : </span>
              </template>
              <template v-if="item" slot-scope="{ item }">
                <span style="margin-left: 90px" class="name">{{
                  item.label
                }}</span>
                <!-- <span class="addr">{{ item.AirportCode3 }}</span> -->
              </template>
            </ByAutocomplete>
          </ByFormItem>
          <ByFormItem prop="end" required class="check-form-item">
            <ByAutocomplete ref="end" placeholder="Destination Airport" v-model="formData.endLabel" :fetchSuggestions="
                (queryString, cb) =>
                  fetchSuggestions(queryString, cb, endAirDatas)
              " valueKey="value" labelKey="label" @select="
                (item) => {
                  formData.end = item.value;
                  formData.endItem = item;
                  $refs['unit'].focus();
                }
              ">
              <template slot="prefix">
                <svg-icon size="20" name="juxing1"></svg-icon>
                <span>To : </span>
              </template>
              <template v-if="item" slot-scope="{ item }">
                <span style="margin-left: 70px" class="name">{{
                  item.label
                }}</span>
                <span style="float: right" class="name">{{
                  item.CountryNameEn
                }}</span>
                <!-- <span class="addr">{{ item.AirportCode3 }}</span> -->
              </template>
            </ByAutocomplete>
          </ByFormItem>
        </div>
        <div class="check-form_flex check-form__group">
          <ByFormItem prop="unit" required class="check-form-item">
            <CheckInput ref="unit" maxlength="4" onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')" v-model="formData.unit" placeholder="Total Unit">
              <template slot="prefix">
                <svg-icon size="20" name="juxing3"></svg-icon>
              </template>
              <template slot="custom_suffix">
                <CheckSelect v-model="formData.unitType" style="width: 130px" :data="[
                    { value: 'CTNS', label: 'Carton' },
                    { value: 'PLTS', label: 'Pallet' },
                    { value: 'WOODEN CASE', label: 'Wooden Case' },
                    { value: 'OTHER', label: 'Other' },
                  ]" class="check-form-item">
                </CheckSelect>
              </template>
            </CheckInput>
          </ByFormItem>
          <ByFormItem prop="weight" required class="check-form-item">
            <CheckInput ref="weight" v-model="formData.weight" type='float' oninput="if(value>9999999.999)value=value.slice(0,value.length-1);if(value.length>11)value=value.slice(0,11)" placeholder="Total Weight">
              <template slot="prefix">
                <svg-icon size="20" name="home_ic_weight"></svg-icon>
              </template>
              <template slot="suffix"> KG </template>
            </CheckInput>
          </ByFormItem>

          <ByFormItem prop="volume" required class="check-form-item">
            <CheckInput ref="volume" v-model="formData.volume" type='float' oninput="if(value>9999999.999)value=value.slice(0,value.length-1);if(value.length>11)value=value.slice(0,11)" placeholder="Total Volume">
              <template slot="prefix">
                <svg-icon size="20" name="home_ic_volume"></svg-icon>
              </template>
              <template slot="suffix"> CBM </template>
            </CheckInput>
          </ByFormItem>

          <ByFormItem :class="['check-form-item']">
            <by-button :class="['check__button', { 'button-active': buttonActive }]" @click="goCheck">ENQUIRY</by-button>
          </ByFormItem>
        </div>
      </ByForm>
    </div>
  </div>
</template>

<script>
import { post, fetch } from "@/ask/axios";
import bus from "@/ask/eventBus";
import ByAutocomplete from "./components/ByAutocomplete.vue";
import CheckInput from "./components/CheckInput.vue";
import CheckSelect from "./components/CheckSelect.vue";
import ByForm from "./components/ByForm.vue";
import ByFormItem from "./components/ByFormItem.vue";
export default {
  name: "Air",
  components: {
    ByAutocomplete,
    CheckInput,
    CheckSelect,
    ByForm,
    ByFormItem,
  },
  data() {
    return {
      formData: {
        from: "",
        end: "",
        fromLabel: "",
        unit: "",
        unitType: "CTNS",
        volume: "",
        weight: "",
      },
      rules: {
        from: { required: true },
        end: { required: true },
        unit: { required: true },
        weight: { required: true },
        volume: { required: true },
      },
      startAirDatas: [],
      endAirDatas: [],
      //机场数据策略
      airStrategy: {
        //给数据加 value和label   两  字段
        base: function (airs) {
          airs.forEach((ai, index) => {
            airs[index].label = `${ai.AirportCode3} (${ai.AirportNameEn}) `;
            airs[index].value = ai.AirportCode3;
          });
          return airs;
        },
        start: function (airs) {
          airs = this.base(airs);
          let allAir = airs
            .map((ai, index) => {
              return ai.AirportCode3;
            })
            .join(",");
          airs.unshift({
            label: "All airports",
            value: allAir,
          });
          return airs;
        },
        end: function (airs) {
          airs = this.base(airs);
          return airs;
        },
      },
      buttonActive: false,
    };
  },
  watch: {
    formData: {
      handler(val) {
        // debugger;
        // delete val.volume
        // val.forEach((v,k)=>{
        for (let k in val) {
          if (this.rules.hasOwnProperty(k)) {
            if (!val[k]) {
              this.buttonActive = false;
              return;
            }
          }
        }

        // })
        this.buttonActive = true;
      },
      deep: true,
    },
  },
  mounted() {
    this.getStartAirport();
    this.getDestAirApi();
  },
  methods: {
    //起时机场数据
    getStartAirport() {
      let url = this.$api04 + "/Air/api/Airline/StartAirportQuery";
      fetch(url).then((res) => {
        //console.log("🚀 ~ res", res);
        this.startAirDatas = this.airStrategy["start"](res.Results);
      });
    },
    //目的机场-接口
    getDestAirApi() {
      let url = this.$api04 + "/Basics/api/Airport/QueryPort";
      post(url, { DataClass: 7 }).then((res) => {
        bus.$emit("passEndAir", res.Results);
        //console.log("🚀 ~ res", res);
        this.endAirDatas = this.airStrategy["end"](res.Results);
      });
    },
    //调用弹窗去查价
    goCheck() {
      this.$refs["ruleForm"].validate((valid) => {
        if (typeof valid === "string") {
          return this.$refs[valid].focus();
        }
        //console.log("🚀 ~ goCheck");
        //   this.addField();
        this.$emit("checkBtn", this.formData, "air");
      });
    },

    // //增加跳转多传的字段
    // addField() {
    //   //   目的地  'AirportNameEn','CountryNameEn'
    //   const selectEnd = this.endAirDatas.find((air) => {
    //     return air.AirportCode3 === this.formData.end;
    //   });
    // //   this.formData["code2En"] = selectEnd.AirportNameEn;
    // //   this.formData["code2Country"] = selectEnd.CountryNameEn;
    //   this.formData["startItem"]=selectEnd

    //   //    起始地 ,'AirportNameEn'
    //   const selectStart = this.startAirDatas.find((air) => {
    //     return air.AirportCode3 === this.formData.from;
    //   });
    //   this.formData["endItem"]=selectStart

    // },
    //筛选数据的函数
    fetchSuggestions(queryString, cb, lists) {
      var datas = lists;
      var results = queryString
        ? datas.filter(this.createFilter(queryString))
        : datas;
      cb(results);
    },
    // 筛选数据的方式
    createFilter(queryString) {
      return (air) => {
        return air.label.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.check-form_flex {
  display: flex;
  .check-form-item {
    flex: 1;
  }
}
// .check-form__group{
//     .check-form-item + .check-form-item {
//   margin-left: 30px;
// }
// }

// .check-center .check__button{
//   background: #96aedc;
//   transition: all .2s ease-in-out;
// }
.check__button.button-active {
  background: #fff;
}
.check-form-item {
  /deep/ .el-scrollbar__wrap {
    //display: contents !important;
    margin-bottom: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/reception/checkPrice/Air.vue